const GBP = 'GBP';

export const currenciesIcons = {
  [GBP]: '\u00A3',
};
